import Dexie from "dexie";
import IActividadFisica from "../interfaces/IActividadFisica";
import IAlarma from "../interfaces/IAlarma";
import IAlimento from "../interfaces/IAlimento";
import ICaloriasDia from "../interfaces/ICaloriasDia";
import IDatosIniciales from "../interfaces/IDatosIniciales";
import IParam from "../interfaces/IParam";
import IPesoSemanal from "../interfaces/IPesoSemanal";
import IUsuario from "../interfaces/IUsuario";

class AcrofitDatabase extends Dexie{
    public usuarios:Dexie.Table<IUsuario, string>;
    public cat_actividades_fisicas:Dexie.Table<IActividadFisica, string>;
    public datos_iniciales:Dexie.Table<IDatosIniciales, string>;
    public calorias_dia:Dexie.Table<ICaloriasDia, string>;
    public params:Dexie.Table<IParam, string>;
    public alarmas:Dexie.Table<IAlarma, string>;
    public alimentos:Dexie.Table<IAlimento, string>;
    public pesos_semanales:Dexie.Table<IPesoSemanal, string>;

    constructor() {  
        super("bdd_contador_calorias");
        
        //
        // Define tables and indexes
        // (Here's where the implicit table props are dynamically created)
        //
        this.version(1).stores({
            usuarios: "id,correo,nombres,apellidos,altura,genero,fecha_nacimiento,last_update",
            cat_actividades_fisicas: "id,valor,nombre",
            datos_iniciales: "id,edad,peso,actividad_fisica,fecha_registro,calorias_dia,peso_objetivo,kilos_semanales",
            calorias_dia:"fecha_registro,datos_iniciales_id,fecha,detalle,calorias,id,horario_comida,alimento,cantidad",
            params:"param,value",
            alarmas:"usuario_id,desayuno,media_manana,almuerzo,media_tarde,cena,activo,last_update",
            alimentos:"id,nombre,porcion,equivalencia,calorias,estado,categoria,foto,usuario_id,personalizado",
            pesos_semanales:"fecha_registro,datos_iniciales,peso"
        });
        
        // The following lines are needed for it to work across typescipt using babel-preset-typescript:
        this.usuarios = this.table("usuarios");
        this.cat_actividades_fisicas = this.table("cat_actividades_fisicas");
        this.datos_iniciales = this.table("datos_iniciales");
        this.calorias_dia = this.table("calorias_dia");
        this.params = this.table("params");
        this.alarmas = this.table("alarmas");
        this.alimentos = this.table("alimentos");
        this.pesos_semanales = this.table("pesos_semanales");
      }
}

const db = new AcrofitDatabase();
export default db;